/**
 * AI 設定（`admin.ai_settings` 權限）。
 *
 * 金鑰只進不出：更新時可以送明文，讀取永遠只拿得到末四碼。前端沒有任何路徑可以
 * 取回完整金鑰——那個功能的唯一用途是外洩。
 */

import { apiFetch, type Schemas } from './core';

export type AiSettings = Schemas['AiSettingsViewDto'];
export type AiSettingsTestResult = Schemas['AiSettingsTestResultDto'];

export interface AiSettingsPatch {
  enabled?: boolean;
  provider?: string;
  model?: string;
  base_url?: string;
  timeout_ms?: number;
  /** 新金鑰明文；**空字串代表清掉**，不傳代表不動。 */
  api_key?: string;
}

export function listAiSettings(): Promise<{ items: AiSettings[] }> {
  return apiFetch<{ items: AiSettings[] }>('/admin/ai-settings', { method: 'GET' });
}

export function updateAiSettings(feature: string, patch: AiSettingsPatch): Promise<AiSettings> {
  return apiFetch<AiSettings>(`/admin/ai-settings/${encodeURIComponent(feature)}`, {
    method: 'PATCH',
    body: patch,
  });
}

/** 實際打一次供應商確認可用；只送幾個 token。 */
export function testAiSettings(feature: string): Promise<AiSettingsTestResult> {
  return apiFetch<AiSettingsTestResult>(`/admin/ai-settings/${encodeURIComponent(feature)}/test`, {
    method: 'POST',
  });
}
